import React from 'react'
import PropTypes from 'prop-types'
import './style.css'

import {Collapse} from 'react-collapse'
import NRTFormInput from "../../../components/_common/_form/FormInput"
import NRTButton from "../../../components/_common/_buttons/Button"
import CirclePlus from "../../../components/_common/_icons/CirclePlus"
import CircleMinus from "../../../components/_common/_icons/CircleMinus"
import CircleRemove from "../../../components/_common/_icons/CircleRemove"
import NRTFormStateManager from "../../../components/_common/_form/FormStateManager"
import NRTHorizontalStack from "../../../components/_common/_containers/HorizontalStack"
import Fade from "../../../components/_common/_transitions/Fade"
import {AdminSectionContentTypeEnum} from "../../../enums/AdminSectionContentTypeEnum"
import _ from 'lodash'

class NRTSectionForm extends React.Component {

    state = {
        isOpen: false,
        selectedContentType: null,
        contentType: this.props.section.contentType
    }



    setOpen = (openState) => {
        this.setState({isOpen: openState})
    }

    onFormChange = (form) => {
        this.setState({
            form,
            contentType: form.values.contentType,
            selectedContentType: _.get(form, 'values.contentType', null),
            showingReleaseData: _.get(form, 'values.showReleaseData', false),
        })
    }

    onSaveButtonClick = () => {
        this.props.onSaveSection({
            ...this.props.section,
            ...this.state.form.values
        })
    }


    render() {

        const {
            section,
            onRemoveSectionButtonClick
        } = this.props

        const {
            showingReleaseData,
            selectedContentType,
            isOpen,
            contentType
        } = this.state

        const sections = {
            1: 'Produto',
            2: 'Serviço',
            3: 'Curso',
        }
        return (
            <div style={{background: '#fff'}}>
                <div className="nrt-form-section">
                    <span className="title" onClick={() => this.setOpen(!isOpen)}>
                        {section.title}
                    </span>

                    <div className="nrt-form-section-icons">
                        {!isOpen ?
                            <a className="collapse-icon" onClick={() => this.setOpen(!isOpen)}>
                                <CirclePlus/>
                            </a>
                            :
                            <a className="collapse-icon" onClick={() => this.setOpen(!isOpen)}>
                                <CircleMinus/>
                            </a>
                        }
                        <a className="remove-section-icon" title={'Remover Seção'}
                           onClick={() => onRemoveSectionButtonClick(section.id)}>
                            <CircleRemove/>
                        </a>

                    </div>
                </div>

                <Collapse isOpened={isOpen}>
                    <NRTFormStateManager nestedForm onStateChange={this.onFormChange}>
                        <NRTHorizontalStack style={{padding: '1rem', marginTop: '1rem', border: '1px solid #cecece'}}
                                            fractions={[1]}>

                            <NRTFormInput label={'Título da Seção'}
                                          name={'title'}
                                          value={section.title}/>

                            <NRTFormInput name={'contentType'}
                                          label={'Tipo de Conteúdo'}
                                          type={'select'}
                                          value={section.contentType}
                                          customProps={{
                                              options: [
                                                  {
                                                      value: 1,
                                                      label: 'Produtos'
                                                  },
                                                  {
                                                      value: 2,
                                                      label: 'Serviços'
                                                  },
                                                  {
                                                      value: 3,
                                                      label: 'Cursos'
                                                  },
                                              ]
                                          }}
                            />

                            {
                                selectedContentType === AdminSectionContentTypeEnum.Curso &&
                                <Fade in={true} duration={300}>

                                    <NRTFormInput
                                        name={'courseType'}
                                        label={'Tipo de Curso'}
                                        value={section.courseType}
                                        type={'radiogroup'}
                                        customProps={{
                                            options: [
                                                {
                                                    value: 1,
                                                    display: 'Presencial'
                                                },
                                                {
                                                    value: 2,
                                                    display: 'Virtual'

                                                },
                                                {
                                                    value: 3,
                                                    display: 'InCompany'

                                                }
                                            ]
                                        }}
                                    />

                                </Fade>
                            }

                            {/*Caso mostrando produto */}

                            <NRTFormInput name={'showReleaseData'}
                                          label={'Exibir'}
                                          type={'select'}
                                          value={section.showReleaseData}
                                          customProps={{
                                              options: [
                                                  {
                                                      value: false,
                                                      label: `Dados do ${sections[contentType]}`
                                                  },
                                                  {
                                                      value: true,
                                                      label: `Dados da ${contentType == 3 ? 'Turma' : 'Versão'}`
                                                  }
                                              ]
                                          }}
                            />

                            {
                                showingReleaseData &&
                                <React.Fragment>

                                    <NRTFormInput
                                        label={'Mostrar nome do(a):'}
                                        type={'select'}
                                        style={{
                                            marginTop: '1.5rem'
                                        }}
                                        value={(() => {
                                            if (_.get(section, 'visibleContentFields.releaseName', false))
                                                return 2

                                            if (_.get(section, 'visibleContentFields.name', false))
                                                return 1

                                            return 0
                                        })()}
                                        customProps={{
                                            options: [
                                                {
                                                    value: 1,
                                                    label: `${sections[contentType]}`
                                                },
                                                {
                                                    value: 2,
                                                    label: `${contentType == 3 ? 'Turma' : 'Versão'}`
                                                },
                                            ]
                                        }}
                                        onChange={(name, value) => {
                                            const visibleCouseInput = this.refs['visibleCourseNameCheckbox']
                                            const visibleReleaseInput = this.refs['visibleReleaseNameCheckbox']

                                            if (visibleCouseInput && visibleReleaseInput) {
                                                visibleCouseInput.setValue(value === 1)
                                                visibleReleaseInput.setValue(value === 2)
                                            }

                                        }}

                                    />

                                    <NRTFormInput
                                        name={'visibleContentFields.name'}
                                        type={'checkbox'}
                                        value={section.visibleContentFields.name}
                                        ref={'visibleCourseNameCheckbox'}
                                        style={{
                                            opacity: 0,
                                            position: 'absolute'
                                        }}

                                    />

                                    <NRTFormInput
                                        name={'visibleContentFields.releaseName'}
                                        type={'checkbox'}
                                        value={section.visibleContentFields.releaseName}
                                        ref={'visibleReleaseNameCheckbox'}
                                        style={{
                                            opacity: 0,
                                            position: 'absolute'
                                        }}
                                    />


                                    <NRTHorizontalStack style={{padding: '.8rem'}} fractions={[1, 1]}>


                                        <NRTFormInput
                                            name={'visibleContentFields.description'}
                                            type={'checkbox'}
                                            value={section.visibleContentFields.description}
                                            customProps={{display: 'Descrição'}}
                                        />

                                        <NRTFormInput
                                            name={'visibleContentFields.image'}
                                            type={'checkbox'}
                                            value={section.visibleContentFields.image}
                                            customProps={{display: 'Imagem'}}
                                        />

                                        <NRTFormInput
                                            name={'visibleContentFields.value'}
                                            type={'checkbox'}
                                            value={section.visibleContentFields.value}
                                            customProps={{display: 'Valor'}}
                                        />
                                        {
                                            selectedContentType === AdminSectionContentTypeEnum.Curso &&
                                            <NRTFormInput
                                                name={'visibleContentFields.location'}
                                                type={'checkbox'}
                                                value={section.visibleContentFields.location}
                                                customProps={{display: 'Local'}}
                                            />
                                        }

                                        {selectedContentType === AdminSectionContentTypeEnum.Curso &&
                                        <NRTFormInput
                                            name={'visibleContentFields.date'}
                                            type={'checkbox'}
                                            value={section.visibleContentFields.date}
                                            customProps={{display: 'Data'}}
                                        />
                                        }

                                        {selectedContentType === AdminSectionContentTypeEnum.Curso &&
                                        <NRTFormInput
                                            name={'visibleContentFields.workload'}
                                            type={'checkbox'}
                                            value={section.visibleContentFields.workload}
                                            customProps={{display: 'Carga horária'}}
                                        />
                                        }

                                    </NRTHorizontalStack>
                                </React.Fragment>
                            }


                            {
                                showingReleaseData === false &&
                                <NRTHorizontalStack style={{padding: '.8rem'}} fractions={[1, 1]}>

                                    <NRTFormInput
                                        name={'visibleContentFields.name'}
                                        type={'checkbox'}
                                        value={section.visibleContentFields.name}
                                        customProps={{display: 'Nome'}}
                                    />


                                    <NRTFormInput
                                        name={'visibleContentFields.description'}
                                        type={'checkbox'}
                                        value={section.visibleContentFields.description}
                                        customProps={{display: 'Descrição Resumida'}}
                                    />

                                    <NRTFormInput
                                        name={'visibleContentFields.image'}
                                        type={'checkbox'}
                                        value={section.visibleContentFields.image}
                                        customProps={{display: 'Imagem'}}
                                    />
                                    {selectedContentType === AdminSectionContentTypeEnum.Curso &&
                                    <NRTFormInput
                                        name={'visibleContentFields.type'}
                                        type={'checkbox'}
                                        value={section.visibleContentFields.type}
                                        customProps={{display: 'Tipo'}}
                                    />
                                    }

                                </NRTHorizontalStack>
                            }

                            <NRTHorizontalStack fractions={[1]}>
                                <NRTButton onClick={this.onSaveButtonClick}>
                                    Salvar
                                </NRTButton>
                            </NRTHorizontalStack>

                        </NRTHorizontalStack>
                    </NRTFormStateManager>
                </Collapse>
            </div>
        )
    }
}

NRTSectionForm.propTypes = {
    section: PropTypes.object.isRequired,
    onRemoveSectionButtonClick: PropTypes.func.isRequired,
    onSaveSection: PropTypes.func.isRequired,
}

NRTSectionForm.defaultProps = {}

export default NRTSectionForm



// WEBPACK FOOTER //
// ./src/components/_admin/SectionForm/index.js